// extracted by mini-css-extract-plugin
module.exports = {"reportContainer":"report_reportContainer__247Rv"};